import BreadcrumbGroup, { BreadcrumbGroupProps } from '@cloudscape-design/components/breadcrumb-group';
import { navigate } from '../router';

export interface BreadcrumbsProps {
  readonly items: BreadcrumbGroupProps.Item[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <BreadcrumbGroup
      items={items}
      onFollow={(event) => {
        event.preventDefault();
        navigate(event.detail.href);
      }}
    />
  );
}
